import { render, staticRenderFns } from "./DealWizardContainer.vue?vue&type=template&id=bd0a5b28&scoped=true"
import script from "./DealWizardContainer.vue?vue&type=script&lang=js"
export * from "./DealWizardContainer.vue?vue&type=script&lang=js"
import style0 from "./DealWizardContainer.vue?vue&type=style&index=0&id=bd0a5b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0a5b28",
  null
  
)

export default component.exports